import React from 'react';
import './urgency.scss';

interface UrgencyIconProps {
  urgencyValue: number;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

const UrgencyIcon: React.FC<UrgencyIconProps> = ({
  urgencyValue,
  width = 16,
  height = 16,
  style,
}) => {
  // Map urgency value to corresponding CSS class
  const getClassByUrgency = () => {
    switch (urgencyValue) {
      case 5:
        return 'urgent-icon';
      case 4:
        return 'high-icon';
      case 3:
        return 'medium-icon';
      case 2:
        return 'low-icon';
      case 1:
        return 'parked-icon';
      default:
        return ''; // Default empty class
    }
  };

  return (
    <div
      className={getClassByUrgency()}
      style={{ width: `${width}px`, height: `${height}px`, ...style }}
    ></div>
  );
};

export default UrgencyIcon;
